import { html, css, SoloLitElement } from '@core/solo-lit-element';
import '@bog-design-system/bd-font';

class SoloSeoTextField extends SoloLitElement {
    static get is() {
        return 'solo-seo-text-field';
    }

    static get styles() {
        return css``;
    }

    render() {
        return html``;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
            paddingTop: {
                type: Boolean,
                reflect: true,
                attribute: 'padding-top',
            },
            islast: {
                type: Boolean,
                reflect: true,
                attribute: 'is-last',
            },
            eventName: {
                type: String,
                attribute: 'event-name',
            },
        };
    }

    constructor() {
        super();
        this.ref = {};
    }

    connectedCallback() {
        super.connectedCallback();
        const {$ref, $id} = this.ref;
        if ($ref && $id) {
            this.apiCall(`pages/getSeoTexts/${$ref}/${$id}`)
                .then((res) => {
                    this.data = res.json.data;
                    if (this.data?.title || this.data?.shortDesc) {
                        this._generateTextField();
                    }
                })
                .catch((err) => console.error(err));
        }
        this._deleteTextField();
    }

    _deleteTextField() {
        const _bogApp = document.getElementsByTagName('solo-app');
        this._content = _bogApp?.[0]?.shadowRoot?.querySelector('#content') ?? null;
        const seoTextField = this._content?.querySelector('solo-seo-text-field');
        if (seoTextField) {
            this._content?.removeChild(seoTextField);
        }
    }

    _generateTextField() {
        const _bogApp = document.getElementsByTagName('solo-app');
        this._content = _bogApp?.[0]?.shadowRoot?.querySelector('#content') ?? null;
        const _contentWidth = this._content?.getBoundingClientRect().width;

        const _div = document.createElement('div');
        _div.setAttribute('id', 'seoTextFieldWrapper');
        if (this.islast) {
            _div.classList.add('is-last');
        }
        _div.innerHTML = `
      <script>
      </script>
      <style>
        #seoTextFieldWrapper {
          display: flex;
          background-color: var(--section-background-color, transparent);
          overflow: hidden;
        }
        
        #seoTextField {
          display: flex;
          flex-direction: column;
          align-self: stretch;
          max-width: ${_contentWidth < 1296 ? _contentWidth : 1296}px;
          justify-content: center;
          padding: var(--size-24) var(--border-space);
          padding-bottom: var(--section-space);
          margin: auto;
          text-align: left;
          width: 100%;
          color: var(--color-invert-component-tr-30);
        }

        #seoTextField .textfield-desc h2,
        #seoTextField .textfield-desc h3,
        #seoTextField .textfield-desc h4,
        #seoTextField .textfield-desc h5 {
          color: var(--color-invert-component-tr-30)!important;
        }

        #seoTextField .textfield-desc {
          height: auto;
          transition: all 0.3s ease-in-out;
          font-size: 14px;
          z-index: -1;
          display: none;
        }
        #seoTextField.expanded div#textfield-desc {
          margin-bottom: 12px;
        }
        #seoTextField h4 {
          font-size: 24px;
          padding: 12px 0px;
          margin: 0px;
          font-weight: 700;
          color: var(--color-invert-component-tr-20);
        }
        #seoTextField .short-desc {
          font-size: 14px;
          font-weight: 400;
          color: var(--color-invert-component-tr-20);
        }
        #seoTextField a {
          color: var(--button-text-low);
          font-size: 13px;
          font-weight: 500;
          font-family: 'BOG', sans-serif;
          display: inline;
          cursor: pointer;
        }
        #seoTextField.expanded a#btnMore,
        #seoTextField:not(.expanded) a#btnLess,
        #seoTextField:not(.expanded) div#textfield-desc {
          visibility: hidden;
          opacity: 0;
          height: 0px;
        }

        #seoTextField.expanded div#textfield-desc {
          z-index: 1;
        }

        #seoTextField.expanded a#btnMore {
          transition: all 0.5s ease-in-out;
        }
        #seoTextField.is-last {
          padding-top: var(--section-space);
        }

        @media(max-width: 1296px) {
          #seoTextField {
            box-sizing: border-box;
          }
        }
        
        @media(max-width: 768px) {
          #seoTextField h4 {
            font-size: 20px;
          }
        }
        
        @media(max-width: 600px) {
          #seoTextField {
            width: 100%;
            padding-top: var(--size-24);
            padding-bottom: var(--size-64);
          }
        }
      </style>
      
      <div id="seoTextField">
        <h4>${this.data?.title ? this.data?.title : ''}</h4>
        <div id="short-desc" class="short-desc"><p>${this.data?.shortDesc ? this.data?.shortDesc : ''}</p></div>
        <div id="textfield-desc" class="textfield-desc">
          <p>${this.data?.text ? this.data?.text : ''}</p>
        </div>
        <a id="btnMore">
          ${this.data?.btnTitle ? this.data?.btnTitle : ''}
        </a>
        <a id="btnLess">
          ${this.data?.lessBtnTitle ? this.data?.lessBtnTitle : ''}
        </a>
        </div>`;
        if (this._content) {
            this._content.appendChild(_div);
        }

        const btn = this._content?.querySelector('#btnMore');
        btn?.addEventListener('click', (e) => this.clickEvent(e, true));

        const btnLess = this._content?.querySelector('#btnLess');
        btnLess?.addEventListener('click', (e) => this.clickEvent(e, false));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        const btn = this._content?.querySelector('#btnMore');
        btn?.removeEventListener('click', (e) => this.clickEvent(e, true));
        const btnLess = this._content?.querySelector('#btnLess');
        btnLess?.removeEventListener('click', (e) => this.clickEvent(e));
    }

    clickEvent(e, open = false) {
        const seoTextField = this._content?.querySelector('#seoTextField');
        const desc = this._content?.querySelector('#seoTextField .textfield-desc');
        if (open) {
            seoTextField.classList.add('expanded');
            desc.style.display = 'block';
            this.sendAnalyticsEvent('click', `seo_more`, `${this.eventName}`, false, true);
        } else {
            if (seoTextField.classList.contains('expanded')) {
                seoTextField.classList.remove('expanded');
            }
            setTimeout(() => {
                desc.style.display = 'none';
            }, 400);
        }
    }
}

window.customElements.define(SoloSeoTextField.is, SoloSeoTextField);
